import { z } from 'zod';

import { parseDto } from '../../mappers/parseDto';
import type { Transport } from '../../transport/Transport';

import type { PromotionService } from './PromotionService';

const activePromotionsDto = z.object({
  data: z.array(z.object({
    id: z.string(), title: z.string(), description: z.string(),
    type: z.enum(['quantity', 'product', 'cart']),
    discount_type: z.enum(['percent', 'fixed']),
    discount_value: z.number().positive(),
    required_quantity: z.number().int().positive(),
    ends_at: z.string().nullable(),
  })),
});

export function createLaravelPromotionService(transport: Transport): PromotionService {
  return {
    async active(signal) {
      const response = await transport.request({
        method: 'GET', path: '/promotions/active',
        ...(signal !== undefined ? { signal } : {}),
      });
      const parsed = parseDto(activePromotionsDto, response.data, 'GET /promotions/active');
      return parsed.data.map((item) => ({
        id: item.id, title: item.title, description: item.description,
        type: item.type, discountType: item.discount_type,
        discountValue: item.discount_value,
        requiredQuantity: item.required_quantity, endsAt: item.ends_at,
      }));
    },
  };
}
